import { Check, Ban } from "lucide-react";
import { STEPS, statusInfo, toneOf } from "@/lib/statuses";

export const ProgressTracker = ({ status }) => {
  const info = statusInfo(status);
  if (info.step < 0) {
    return (
      <div className="flex items-center gap-3 bg-zinc-100 border border-zinc-300 p-5 text-zinc-700" data-testid="progress-terminated">
        <Ban className="h-5 w-5" />
        <span className="font-semibold">{info.label}: il percorso di consegna è stato interrotto.</span>
      </div>
    );
  }
  const exception = ["red", "orange"].includes(info.tone);
  const fillColor = exception ? toneOf(status).hex : info.step === 4 ? "#059669" : "#E50914";
  const pct = (info.step / (STEPS.length - 1)) * 100;
  return (
    <div data-testid="progress-tracker">
      <div className="relative mx-4 sm:mx-6">
        <div className="absolute top-4 left-0 right-0 h-1 bg-slate-200" />
        <div className="absolute top-4 left-0 h-1 transition-[width] duration-1000 ease-out" style={{ width: `${pct}%`, background: fillColor }} data-testid="progress-fill" />
        <ol className="relative flex justify-between">
          {STEPS.map((label, i) => {
            const done = i < info.step || (i === info.step && info.step === 4);
            const current = i === info.step && info.step !== 4;
            return (
              <li key={label} className="flex flex-col items-center w-0">
                <span
                  className={`h-9 w-9 flex items-center justify-center rounded-full border-2 text-xs font-bold transition-colors duration-500 ${
                    done ? "text-white border-transparent" : current ? "bg-white" : "bg-white border-slate-300 text-slate-400"
                  }`}
                  style={done ? { background: fillColor } : current ? { borderColor: fillColor, color: fillColor } : undefined}
                  data-testid={`progress-step-${i}`}
                >
                  {done ? <Check className="h-4 w-4" /> : i + 1}
                </span>
                <span className={`mt-3 text-[10px] sm:text-xs text-center font-semibold uppercase tracking-wide whitespace-nowrap ${done || current ? "text-slate-900" : "text-slate-400"}`}>
                  {label}
                </span>
              </li>
            );
          })}
        </ol>
      </div>
      {exception && (
        <p className="mt-6 text-sm font-semibold" style={{ color: fillColor }} data-testid="progress-exception">
          Attenzione: {info.label.toLowerCase()}.
        </p>
      )}
    </div>
  );
};
